const MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024;
const MIN_IMG_SIDE_LENGTH = 40;
const SCALE_RATIO = 0.6;
const EXPECT_FACE_SIDE = 144;
const HEADSHOT_MARGIN = 10;
const MIN_ASPECT_RATIO = 0.7;
const MAX_ASPECT_RATIO = 1.3;

const MODEL_FILEPATH = '/models/yolov7-lite-e.onnx';
const INPUT_DIMS = [1, 3, 640, 640];
const OUTPUT_DIMS = [1, 25200, 21];
const RESHAPE_DIMS = [-1, 21];
const CONF_THRESH = 0.45;
const IOU_THRESH = 0.5;
export {
  MAX_FILE_SIZE_BYTES,
  MIN_IMG_SIDE_LENGTH,
  SCALE_RATIO,
  EXPECT_FACE_SIDE,
  HEADSHOT_MARGIN,
  MIN_ASPECT_RATIO,
  MAX_ASPECT_RATIO,
  MODEL_FILEPATH,
  INPUT_DIMS,
  OUTPUT_DIMS,
  CONF_THRESH,
  IOU_THRESH,
  RESHAPE_DIMS,
};
